// kapigen version 0.1.33
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export var google;
(function(google) {
    var protobuf;
    (function(protobuf) {
        var defaultBoolValue = {
            value: false
        };
        var BoolValueWireFormat3 = protobuf.BoolValueWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultBoolValue, wireFormat);
                return message;
            },
            toJson: function toJson(message) {
                return message;
            }
        };
        var defaultDuration = {
            seconds: 0,
            nanos: 0
        };
        var DurationWireFormat3 = protobuf.DurationWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultDuration, wireFormat);
                if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.seconds) {
                    message.seconds = parseInt(wireFormat.seconds);
                }
                return message;
            }
        };
        var defaultEmpty = {};
        var EmptyWireFormat3 = protobuf.EmptyWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultEmpty, wireFormat);
                return message;
            },
            toJson: function toJson(message) {
                return message;
            }
        };
        var defaultFieldMask = {
            paths: []
        };
        var FieldMaskWireFormat3 = protobuf.FieldMaskWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultFieldMask, wireFormat);
                return message;
            },
            toJson: function toJson(message) {
                return message;
            }
        };
        var defaultInt32Value = {
            value: 0
        };
        var Int32ValueWireFormat3 = protobuf.Int32ValueWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultInt32Value, wireFormat);
                return message;
            },
            toJson: function toJson(message) {
                return message;
            }
        };
        var defaultStringValue = {
            value: ""
        };
        var StringValueWireFormat3 = protobuf.StringValueWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultStringValue, wireFormat);
                return message;
            },
            toJson: function toJson(message) {
                return message;
            }
        };
        var defaultTimestamp = {
            seconds: 0,
            nanos: 0
        };
        var TimestampWireFormat3 = protobuf.TimestampWireFormat3 = {
            fromJson: function fromJson(wireFormat) {
                var message = _objectSpread({}, defaultTimestamp, wireFormat);
                if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.seconds) {
                    message.seconds = parseInt(wireFormat.seconds);
                }
                return message;
            },
            toJson: function toJson(message) {
                var wireFormat = _objectSpread({}, message);
                if (message === null || message === void 0 ? void 0 : message.seconds) {
                    wireFormat.seconds = message.seconds.toString();
                }
                return wireFormat;
            }
        };
    })(protobuf = google.protobuf || (google.protobuf = {}));
    var rpc;
    (function(rpc) {
        var Code;
        (function(Code) {
            Code[// Not an error; returned on success
            // 
            // HTTP Mapping: 200 OK
            "OK"] = "ok";
            Code[// The operation was cancelled, typically by the caller.
            // 
            // HTTP Mapping: 499 Client Closed Request
            "CANCELLED"] = "cancelled";
            Code[// Unknown error.  For example, this error may be returned when
            // a `Status` value received from another address space belongs to
            // an error space that is not known in this address space.  Also
            // errors raised by APIs that do not return enough error information
            // may be converted to this error.
            // 
            // HTTP Mapping: 500 Internal Server Error
            "UNKNOWN"] = "unknown";
            Code[// The client specified an invalid argument.  Note that this differs
            // from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
            // that are problematic regardless of the state of the system
            // (e.g., a malformed file name).
            // 
            // HTTP Mapping: 400 Bad Request
            "INVALID_ARGUMENT"] = "invalidArgument";
            Code[// The deadline expired before the operation could complete. For operations
            // that change the state of the system, this error may be returned
            // even if the operation has completed successfully.  For example, a
            // successful response from a server could have been delayed long
            // enough for the deadline to expire.
            // 
            // HTTP Mapping: 504 Gateway Timeout
            "DEADLINE_EXCEEDED"] = "deadlineExceeded";
            Code[// Some requested entity (e.g., file or directory) was not found.
            // 
            // Note to server developers: if a request is denied for an entire class
            // of users, such as gradual feature rollout or undocumented allowlist,
            // `NOT_FOUND` may be used. If a request is denied for some users within
            // a class of users, such as user-based access control, `PERMISSION_DENIED`
            // must be used.
            // 
            // HTTP Mapping: 404 Not Found
            "NOT_FOUND"] = "notFound";
            Code[// The entity that a client attempted to create (e.g., file or directory)
            // already exists.
            // 
            // HTTP Mapping: 409 Conflict
            "ALREADY_EXISTS"] = "alreadyExists";
            Code[// The caller does not have permission to execute the specified
            // operation. `PERMISSION_DENIED` must not be used for rejections
            // caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
            // instead for those errors). `PERMISSION_DENIED` must not be
            // used if the caller can not be identified (use `UNAUTHENTICATED`
            // instead for those errors). This error code does not imply the
            // request is valid or the requested entity exists or satisfies
            // other pre-conditions.
            // 
            // HTTP Mapping: 403 Forbidden
            "PERMISSION_DENIED"] = "permissionDenied";
            Code[// The request does not have valid authentication credentials for the
            // operation.
            // 
            // HTTP Mapping: 401 Unauthorized
            "UNAUTHENTICATED"] = "unauthenticated";
            Code[// Some resource has been exhausted, perhaps a per-user quota, or
            // perhaps the entire file system is out of space.
            // 
            // HTTP Mapping: 429 Too Many Requests
            "RESOURCE_EXHAUSTED"] = "resourceExhausted";
            Code[// The operation was rejected because the system is not in a state
            // required for the operation's execution.  For example, the directory
            // to be deleted is non-empty, an rmdir operation is applied to
            // a non-directory, etc.
            // 
            // Service implementors can use the following guidelines to decide
            // between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
            //  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
            //  (b) Use `ABORTED` if the client should retry at a higher level
            //      (e.g., when a client-specified test-and-set fails, indicating the
            //      client should restart a read-modify-write sequence).
            //  (c) Use `FAILED_PRECONDITION` if the client should not retry until
            //      the system state has been explicitly fixed.  E.g., if an "rmdir"
            //      fails because the directory is non-empty, `FAILED_PRECONDITION`
            //      should be returned since the client should not retry unless
            //      the files are deleted from the directory.
            // 
            // HTTP Mapping: 400 Bad Request
            "FAILED_PRECONDITION"] = "failedPrecondition";
            Code[// The operation was aborted, typically due to a concurrency issue such as
            // a sequencer check failure or transaction abort.
            // 
            // See the guidelines above for deciding between `FAILED_PRECONDITION`,
            // `ABORTED`, and `UNAVAILABLE`.
            // 
            // HTTP Mapping: 409 Conflict
            "ABORTED"] = "aborted";
            Code[// The operation was attempted past the valid range.  E.g., seeking or
            // reading past end-of-file.
            // 
            // Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
            // be fixed if the system state changes. For example, a 32-bit file
            // system will generate `INVALID_ARGUMENT` if asked to read at an
            // offset that is not in the range [0,2^32-1], but it will generate
            // `OUT_OF_RANGE` if asked to read from an offset past the current
            // file size.
            // 
            // There is a fair bit of overlap between `FAILED_PRECONDITION` and
            // `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
            // error) when it applies so that callers who are iterating through
            // a space can easily look for an `OUT_OF_RANGE` error to detect when
            // they are done.
            // 
            // HTTP Mapping: 400 Bad Request
            "OUT_OF_RANGE"] = "outOfRange";
            Code[// The operation is not implemented or is not supported/enabled in this
            // service.
            // 
            // HTTP Mapping: 501 Not Implemented
            "UNIMPLEMENTED"] = "unimplemented";
            Code[// Internal errors.  This means that some invariants expected by the
            // underlying system have been broken.  This error code is reserved
            // for serious errors.
            // 
            // HTTP Mapping: 500 Internal Server Error
            "INTERNAL"] = "internal";
            Code[// The service is currently unavailable.  This is most likely a
            // transient condition, which can be corrected by retrying with
            // a backoff.
            // 
            // See the guidelines above for deciding between `FAILED_PRECONDITION`,
            // `ABORTED`, and `UNAVAILABLE`.
            // 
            // HTTP Mapping: 503 Service Unavailable
            "UNAVAILABLE"] = "unavailable";
            Code[// Unrecoverable data loss or corruption.
            // 
            // HTTP Mapping: 500 Internal Server Error
            "DATA_LOSS"] = "dataLoss";
        })(Code = rpc.Code || (rpc.Code = {}));
    })(rpc = google.rpc || (google.rpc = {}));
})(google || (google = {}));
